
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'Cases',
    loading: 'Loading cases...',
    empty: 'No cases available',
    emptyHint: 'They will be back shortly. In the meantime, the other games are open.',
    emptyCta: 'Go to games',
  },
  ru: {
    title: 'Кейсы',
    loading: 'Загрузка кейсов...',
    empty: 'Нет доступных кейсов',
    emptyHint: 'Скоро вернутся. А пока открыты другие игры.',
    emptyCta: 'К играм',
  },
  uz: {
    title: 'Keyslar',
    loading: 'Keyslar yuklanmoqda...',
    empty: 'Mavjud keyslar yoʻq',
    emptyHint: 'Tez orada qaytadi. Hozircha boshqa oʻyinlar ochiq.',
    emptyCta: 'Oʻyinlarga',
  },
  fa: {
    title: 'کیس‌ها',
    loading: 'در حال بارگذاری کیس‌ها...',
    empty: 'کیسی موجود نیست',
    emptyHint: 'به‌زودی برمی‌گردند. تا آن موقع بازی‌های دیگر باز هستند.',
    emptyCta: 'برو به بازی‌ها',
  },
  pt: {
    title: 'Caixas',
    loading: 'Carregando caixas...',
    empty: 'Nenhuma caixa disponível',
    emptyHint: 'Elas voltam em breve. Enquanto isso, os outros jogos estão abertos.',
    emptyCta: 'Para os jogos',
  },
  tr: {
    title: 'Kasalar',
    loading: 'Kasalar yükleniyor...',
    empty: 'Uygun kasa yok',
    emptyHint: 'Yakında geri gelecekler. Bu arada diğer oyunlar açık.',
    emptyCta: 'Oyunlara',
  },
});
